import { z } from "zod"

export const AdapterPayload = z.object({
  projectID: z.string(),
  sessionID: z.string(),
  messageID: z.string(),
  message: z.unknown(), // Full Message schema from SDK
})

export const AdapterResponse = z.object({
  wsUrl: z.url(),
})

// export type AdapterPayload = z.infer<typeof AdapterPayload>
// export type AdapterResponse = z.infer<typeof AdapterResponse>

